import React, { FC, useState, useEffect } from "react";
import { TComment } from "../../../models/track";
import moment from "moment";
import { storage } from "../../../firebase";
import { RootState } from "../../../store/reducers";
import { connect } from "react-redux";
import { deleteComment } from "../../../store/actions/track";
import { motion } from "framer-motion";

const Comment: FC<{ comment: TComment; uid: string | null }> = ({
  comment,
  uid,
}) => {
  const [uimg, setuimg] = useState<string | null>("");

  useEffect(() => {
    let mounted = true;

    storage
      .ref(`profiles/${comment.user.id}`)
      .getDownloadURL()
      .then((url) => {
        if (mounted) setuimg(url);
      });

    return () => {
      mounted = false;
    };
  });

  return (
    <>
      <motion.div className="comment">
        <div
          className="cuimg"
          style={{
            background: uimg ? `url(${uimg})` : "#ddd",
            backgroundSize: "cover !important",
          }}
        ></div>
        <div className="cbdy">
          <div className="cuname">
            <b>{comment.user.username}</b>
            <span>
              {uid === comment.user.id && (
                <i
                  className="material-icons-outlined md-18"
                  style={{ color: "crimson" }}
                  onClick={async () => {
                    await deleteComment(comment.tid, comment.id);
                  }}
                >
                  delete
                </i>
              )}
            </span>
          </div>
          <div className="ctime">
            <small>{moment(comment.date).fromNow()}</small>
          </div>
          <div className="ccnt">{comment.body}</div>
        </div>
      </motion.div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  uid: state.auth.user.id,
});

export default connect(mapStateToProps)(Comment);
